import ReactOnRails from 'react-on-rails';

import App from '@components/App/index';

ReactOnRails.register({
  App,
});
